import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../brand/Logo';
import { Seal } from '../brand/Seal';
import { programs } from '../../data/programs';
import { products } from '../../data/products';
import { navItems } from '../../data/site';
export function Footer() {
  return <footer className="bg-ink text-cream-light" data-id="element-140" data-mp="5nlwucfmly9y">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-20" data-id="element-141" data-mp="5msy9yqtmf2w">
        <div className="grid gap-12 lg:grid-cols-[1.3fr_1fr_1fr_1fr_1fr]" data-id="element-142" data-mp="p15z3m9kqy6">
          <div data-id="element-143" data-mp="3s25bma8ijfgy">
            <Logo className="text-lg" data-id="element-144" data-mp="3s1m47ngho9h6" />
            <p className="mt-6 max-w-xs font-serif text-2xl leading-snug text-cream" data-id="element-145" data-mp="3s0kgaiedjsi1">
              More choice is better health for all.
            </p>
            <Seal className="mt-10 h-24 w-24 text-cream/50" data-id="element-146" data-mp="3j2s1rggh8ovp" />
          </div>

          <FooterColumn title="Programs" data-id="element-147" data-mp="3e2meech8pojf">
            {programs.slice(0, 5).map(program => <FooterLink key={program.slug} to={`/programs/${program.slug}`} data-id="element-148" data-mp="3942tmfeduisn">
                {program.name}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Pharmacy" data-id="element-149" data-mp="2kba0hbf35i64">
            {products.slice(0, 5).map(product => <FooterLink key={product.slug} to={`/shop/${product.slug}`} data-id="element-150" data-mp="2p5o0jr4p0dh4">
                {product.name}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Republic" data-id="element-151" data-mp="2gc16q6k1pkak">
            {navItems.map(item => <FooterLink key={item.to} to={item.to} data-id="element-152" data-mp="3425cajgsnu47">
                {item.label}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Patients" data-id="element-153" data-mp="380crvaziupdt">
            <FooterLink to="/get-started" data-id="element-154" data-mp="2u1uwqs7aealv">Start intake</FooterLink>
            <FooterLink to="/labs" data-id="element-155" data-mp="2z20vesbz4xdg">Book a lab draw</FooterLink>
            <FooterLink to="/pricing" data-id="element-156" data-mp="2z067d55eop55">Membership pricing</FooterLink>
            <FooterLink to="/about" data-id="element-157" data-mp="1imprphjonzz3">Clinical standards</FooterLink>
          </FooterColumn>
        </div>

        <div className="rule-light mt-16 pt-8" data-id="element-158" data-mp="1nnvp3soagbey">
          <p className="max-w-4xl text-xs leading-relaxed text-cream/55" data-id="element-159" data-mp="1nkhmcjbpq06z">
            Republic is a direct-pay clinical practice. Treatment is prescribed only where clinically
            appropriate following review by a licensed clinician. Compounded medications are not
            FDA-approved products and are dispensed by US-licensed 503A and 503B pharmacies. This
            site is for informational purposes and is not a substitute for individual medical advice.
          </p>
          <div className="mt-8 flex flex-col gap-4 text-xs text-cream/55 sm:flex-row sm:items-center sm:justify-between" data-id="element-160" data-mp="ks5aknghmv7g">
            <p data-id="element-161" data-mp="bta4dbdg1l45">© {new Date().getFullYear()} Republic Health, Inc.</p>
            <div className="flex gap-6" data-id="element-162" data-mp="bvnwpcgqoj80">
              <Link to="/about" className="hover:text-cream" data-id="element-163" data-mp="6v06gt0c46eu">
                Privacy
              </Link>
              <Link to="/about" className="hover:text-cream" data-id="element-164" data-mp="267ujz9mwqqgo">
                Terms
              </Link>
              <Link to="/about" className="hover:text-cream" data-id="element-165" data-mp="21884etjlwy4p">
                HIPAA notice
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}
function FooterColumn({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-166" data-mp="2ihaj561nwfpk">
      <h2 className="text-[0.6875rem] uppercase tracking-label text-cream/50" data-id="element-167" data-mp="2iivaynwldkjq">{title}</h2>
      <ul className="mt-6 flex flex-col gap-3" data-id="element-168" data-mp="2nh6l6zqstx2h">{children}</ul>
    </div>;
}
function FooterLink({
  to,
  children
}: {
  to: string;
  children: React.ReactNode;
}) {
  return <li data-id="element-169" data-mp="1us82o1irkswn">
      <Link to={to} className="text-sm text-cream/80 transition-colors duration-150 ease-republic hover:text-cream" data-id="element-170" data-mp="1urzm9znfn5gp">
        {children}
      </Link>
    </li>;
}